const TabBarNavigation = () => {};

export default TabBarNavigation;
